export default __webpack_public_path__ + "static/media/alexandr-ricov.669a40b7.png";